//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  angular.module('curalate').directive('mediaError', () => ({
    restrict: 'A',
    scope: {
      onMediaError: '&?',
      fallbackSrc: '@',
    },
    link: function postLink(scope, element) {
      let fallbackAttempted;
      element.bind('error', function() {
        if (!_(scope.fallbackSrc).isUndefined() && !fallbackAttempted) {
          angular.element(this).attr('src', scope.fallbackSrc);
          fallbackAttempted = true;
        }

        if (_(scope.onMediaError).isFunction()) {
          scope.onMediaError();
        }
      });
    },
  }));
})();
